import { createApi } from '@reduxjs/toolkit/query/react';

import { axiosBaseQuery } from '../../../shared/services/baseQuery';

import {
  type BaseProps,
  ChatModuleType,
  type ListViewerApiResponse,
  type PostCustomListProps,
  type PostFormDataProps,
  type SodListApiResponse,
} from './chatModuleType';

const chatModuleApi = createApi({
  reducerPath: ChatModuleType.EP_SLICE_NAME,
  baseQuery: axiosBaseQuery({}),
  endpoints: () => ({}),
});

// Extend API with additional endpoints
export const chatModuleEndPoints = chatModuleApi.injectEndpoints({
  endpoints: (builder) => ({
    postCustomList: builder.mutation<unknown, PostCustomListProps>({
      query: ({ url, data, queryParams }) => ({
        url,
        method: 'POST',
        params: { ...queryParams },
        data,
      }),
      transformResponse: (response: ListViewerApiResponse) => {
        if (
          response.success ||
          Number(response.errorcode) === 0 ||
          Number(response.errorcode) === 49 ||
          Number(response.errorcode) === 200
        ) {
          return response;
        }

        throw new Error(response.error);
      },
    }),
    getCustomList: builder.query<unknown, BaseProps>({
      query: ({ url, data }) => ({
        url,
        params: { ...data },
      }),
      transformResponse: (response: ListViewerApiResponse) => {
        if (response.success) {
          return response;
        }

        throw new Error(response.error);
      },
    }),
    getFormData: builder.query<unknown, BaseProps>({
      query: ({ url, data }) => ({
        url,
        params: { ...data },
      }),
      transformResponse: (response: { msg: string; errorcode: string }) => {
        if (
          response.msg === 'success' &&
          (Number(response.errorcode) === 0 ||
            Number(response.errorcode) === 200)
        ) {
          return response;
        }

        throw new Error('Failed to fetch the form');
      },
    }),
    postFormData: builder.mutation<unknown, PostFormDataProps>({
      query: ({ url, data, isECMv6 = false }) => ({
        url,
        method: 'POST',
        data,
        isECMv6,
      }),
    }),
    getSodList: builder.mutation<unknown, BaseProps>({
      query: ({ url, data }) => ({
        url,
        method: 'POST',
        data,
        isECMv6: true,
      }),
      transformResponse: (response: SodListApiResponse) => {
        if (response.status === 200) {
          return response;
        }

        throw new Error(response.message);
      },
    }),
    validateAttachment: builder.mutation<unknown, FormData>({
      query: (formData) => ({
        url: '/api/v5/requestmcp/validateAttachment',
        method: 'POST',
        data: formData,
      }),
    }),
  }),
});

export const {
  useLazyGetCustomListQuery,
  usePostCustomListMutation,
  useLazyGetFormDataQuery,
  usePostFormDataMutation,
  useGetSodListMutation,
  useValidateAttachmentMutation,
} = chatModuleEndPoints;

export default chatModuleApi;
